import { Button, Card, Spin } from "antd";
import moment from "moment";
import { useState } from "react";
import EllipsisMenu from "../../../Reuseable/EllipsisMenu/EllipsisMenu";
import { ReactComponent as Cong } from "../../../assets/Icons/portfolioCongIcons.svg";
import { ReactComponent as Edit } from "../../../assets/Icons/portfolioEditIcon.svg";
import { ReactComponent as Trash } from "../../../assets/Icons/portfolioTrashIcon.svg";
import { ReactComponent as Upload } from "../../../assets/Icons/uploadIconPortfolio.svg";
import PortfolioModal from "../PortfolioModal/PortfolioModal";
import PortfolioUploadedFiles from "../PortfolioUploadedFiles/PortfolioUploadedFiles";
import "./PortfolioCards.scss";
import DeleteUserModal from "../../AgencyComp/UserComp/DeleteUserModal";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { deletePortfolio } from "../../../assets/api/agency";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { fetchPortfolios } from "../../../store/portfolioSlice";
import { ExportOutlined, RedoOutlined, UndoOutlined } from "@ant-design/icons";
import {
  downloadPortfolioFile,
  unarchivePortfolio,
} from "../../../assets/api/portfolio";
import { formatCurrency } from "../../../assets/helpers";

const PortfolioCards = ({
  data = [],
  loading,
  setFile,
  handleCreatePortfolio,
  load,
  isEditModalOpen,
  setIsEditModalOpen,
  setOpenDatewiseExportModal,
  setSelectedItem,
  file,
}) => {
  const [selectedPortfolio, setSelectedPortfolio] = useState(null);
  const [isUploadedFiles, setIsUploadedFiles] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [portfolioToDelete, setPortfolioToDelete] = useState(null);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingUndo, setLoadingUndo] = useState(false);
  const [openExportModal, setOpenExportModal] = useState(false);
  const [loadingExport, setLoadingExport] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { token } = useSelector((state) => state.auth);
  const { format } = useSelector((state) => state.priceFormat);
  const [params, setParams] = useState({});

  const handleDeleteClick = (portfolio) => {
    setPortfolioToDelete(portfolio);
    setIsDeleteModalOpen(true);
  };

  const handleExportPortfolio = async (item) => {
    setOpenDatewiseExportModal(true);
    setSelectedItem(item);
  };

  const handleDeleteConfirm = async () => {
    if (!portfolioToDelete?.id || !token) return;

    try {
      setLoadingDelete(true);
      const res = await deletePortfolio({ portfolio_id: portfolioToDelete.id }, token);
      if (res?.status === 200) {
        toast.success(res?.data?.message || 'Portfolio deleted successfully');
        setLoadingDelete(false);
        dispatch(fetchPortfolios());
      }
      setIsDeleteModalOpen(false);
    } catch (err) {
      console.error("Failed to delete portfolio", err);
      toast.error(err?.message || "Failed to delete portfolio");
      setLoadingDelete(false)
    }
  };

  const handleEditClick = (portfolio) => {
    const selected = {
      name: portfolio?.name,
      totalCases: portfolio?.total_cases,
      totalPOS: portfolio?.total_pos,
      total_tos: portfolio?.total_tos,
      uploadedFiles: portfolio?.uploadedFiles || [],
      id: portfolio?.id,
    };

    setSelectedPortfolio(selected);
    setIsEditModalOpen(true);
  };

  const formatCurrency = (value) => {
    if (!value || isNaN(value)) return "-";
    return `₹${Number(value).toLocaleString("en-IN")}`;
  };

   const handleRevertPortfolio = async (portfolio) => {
    try {
      setLoadingUndo(true);
      const res = await unarchivePortfolio(portfolio?.id, token);
      if (res?.status === 200) {
        toast.success(res?.data?.message || "Portfolio reverted successfully");
        dispatch(fetchPortfolios());
        setLoadingUndo(false);
      }
    } catch (error) {
      setLoadingUndo(false);
    }
  }


  return (
    <div className="portfolio-cart">
      <div className="portfolioCardsMain">
        {data.length === 0 && !loading ? (
          <p className="noDataText">No portfolios available.</p>
        ) : (
          data?.map((item, index) => {
            const transformed = {
              portfolioNo: item?.name,
              date: moment(item?.acquired_on).format("DD MMM YYYY"),
              total_cases: `${item?.total_cases} accounts`,
              total_pos: formatCurrency(item?.total_pos, format),
              broughtAt: formatCurrency(item?.total_tos, format),
              recovery:
                item?.recovery > 0
                  ? `${formatCurrency(item?.recovery, format)} (${
                      item?.recovery_percent
                    }%)`
                  : item?.recovery,
            };

            if (loading) {
              return <Card loading={true} />;
            }
            return (
              <div className={`portfolioCardBox`} key={index}>
                <div className="cardHeader">
                  <div className="portfolioNumber">
                    <h2>{transformed.portfolioNo}</h2>
                    {!item?.is_archived &&
                      (loadingExport === item?.id ? (
                        "Downloading..."
                      ) : (
                        <EllipsisMenu
                          options={[
                            {
                              icon: <Edit />,
                              label: "Edit Details",
                              highlight: true,
                              onClick: () => handleEditClick(item),
                            },
                            {
                              icon: <Cong />,
                              label: "Config",
                              highlight: false,
                              onClick: () =>
                                navigate(
                                  `/portfolio/${item.id}?redirectFromConfig=true`,
                                  {
                                    state: { id: item.id },
                                  },
                                ),
                            },
                            {
                              icon: <Trash />,
                              label: "Delete",
                              highlight: false,
                              onClick: () => handleDeleteClick(item),
                            },
                            {
                              icon: <Upload />,
                              label: "Show Uploaded Files",
                              highlight: false,
                              onClick: () => {
                                setIsUploadedFiles(true);
                                setSelectedPortfolio(item);
                              },
                            },
                            {
                              icon: <ExportOutlined />,
                              label: "Export",
                              highlight: false,
                              onClick: () => handleExportPortfolio(item),
                            },
                          ]}
                        />
                      ))}
                  </div>
                  <div className="addedOnDate">
                    <p>
                      Added on <span>{transformed?.date}</span>
                    </p>
                  </div>
                </div>
                <div className="cardDetailedInfo">
                  <div className="loanData">
                    <p className="title">Total Cases</p>
                    <p className="titleData">{transformed?.total_cases}</p>
                  </div>
                  <div className="totalPrincipalData">
                    <p className="title">Total POS</p>
                    <p className="titleData">{transformed?.total_pos}</p>
                  </div>
                  <div className="broughtData">
                    <p className="title">Total TOS</p>
                    <p className="titleData">{transformed?.broughtAt}</p>
                  </div>
                  <div className="recoveryData">
                    <p className="title">Recovery</p>
                    <p className="titleData">{transformed?.recovery}</p>
                  </div>
                </div>
                {item?.is_archived && (
                  <div className="archived-portfolio-overlay">
                    <div className="menu-wrapper">
                      <Button onClick={() => handleRevertPortfolio(item)} loading={loadingUndo} type="text">
                        {loadingUndo ? null : <UndoOutlined />}
                      </Button>
                    </div>
                  </div>
                )}

              </div>
            );
          })
        )}

        {isEditModalOpen && (
          <PortfolioModal
            isOpen={isEditModalOpen}
            onClose={() => setIsEditModalOpen(false)}
            userData={selectedPortfolio}
            setUserData={setSelectedPortfolio}
            setFile={setFile}
            file={file}
            mode="edit"
            load={load}
            onSave={(data) => {
              handleCreatePortfolio({
                ...data,
                is_edit: true,
                id: selectedPortfolio?.id,
              });
            }}
          />
        )}

        {isDeleteModalOpen && (
          <DeleteUserModal
            open={isDeleteModalOpen}
            userStatus={"Active"}
            onClose={() => setIsDeleteModalOpen(false)}
            onDelete={handleDeleteConfirm}
            message={
              <>
                Are you sure you want to
                <br />
                delete this portfolio?
              </>
            }
            loading={loadingDelete}
          />
        )}

        {isUploadedFiles && (
          <PortfolioUploadedFiles
            isVisible={isUploadedFiles}
            onClose={() => setIsUploadedFiles(false)}
            selectedPortfolio={selectedPortfolio}
          />
        )}
      </div>
    </div>
  );
};

export default PortfolioCards;
